import React, {useEffect, useState} from "react";
import { IProfile } from '../../../interface/IProfile.ts';
import { useProfileApi } from '../../../features/auth/hooks/use-profile-api.ts'
import { ApiResponseType } from "../../../features/api/types.ts";
import { useListsApi } from "../../../features/auth/hooks/use-lists-api.ts";
import { IOption } from "../../../interface/IOption.ts";
import Checkboxes from "../../Form/Checkboxes.tsx";
import Form from "../../Form/Form.tsx";
import ApiCheck from '../../Structure/ApiCheck.tsx';

const TabCoachingForms = ({
    profile,
    setProfile
}:{
    profile:IProfile
    setProfile: Function
}) => {
    const [coachingFormList, setCoachingFormList] = useState<Array<any>>([]);
    const [coachingFormsLoading, setCoachingFormsLoading] = useState<boolean>(true);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState<string>('');
    const [responseMessageClass, setResponseMessageClass] = useState<string>('');
    const { postProfile } = useProfileApi();
    const [errors, setErrors] = useState<any>({});
    const { getList } = useListsApi();
    const [apiErrors, setApiErrors] = useState<any>();

    const [unSavedChanges, setUnSavedChanges] = useState(false);

    const [formData, setFormData] = useState<IProfile>({
        coaching_forms: profile.coaching_forms ?? [],
    });

    const handleChange = (event, name = '', value = null) => {
        setFormData({ ...formData, [name ? name : event.target.name]: value ? value : event.target.value });
        !unSavedChanges && setUnSavedChanges(true);
    };

    const expectedAmountCoachingForms:number = 3;

    const handleSubmit = (event) => {
        event.preventDefault();
        setUnSavedChanges(false);
        setIsLoading(true);

        let postedData:{coaching_forms:Array<string>} = {
            coaching_forms: [],
        };
        let coachingFormIds = formData.coaching_forms!.map(el => {
            return el.value;
        });
        postedData.coaching_forms = coachingFormIds;

        setErrors({});
        postProfile(postedData).then(res => {
            setIsLoading(false);
            if (res.type === ApiResponseType.OK) {
                if (res.payload.success)  {
                    setResponseMessage('Erfolgreich gespeichert');
                    setResponseMessageClass('success');
                    setProfile({...profile, ...postedData});
                    setTimeout(() => {
                        setResponseMessage('');
                    }, 5000);
                }
            } else {
                let errors = res.payload.errors!;
                if (!errors.general_error) {
                    setResponseMessage('Fehler. Bitte korrigieren Sie den Fehler und versuchen Sie es erneut.');
                    setResponseMessageClass('error');
                }
                setErrors(errors);
            }
        })
    }

    useEffect(() => {
        let formDataClone = structuredClone(formData);
        getList('coaching_forms').then(res => {
            let optionList:Array<IOption> = [];
            if (res) {
                res.forEach((item:any) => {
                    optionList.push({
                        value: item.id,
                        label: item.label
                    });
                });
                setCoachingFormList(optionList);
                let coachingFormsFromOptions:Array<IOption> = [];
                coachingFormsFromOptions = optionList.filter(singleCoachingFormOption => {
                    return profile.coaching_forms?.includes(singleCoachingFormOption.value);
                });
                formDataClone = { ...formDataClone, coaching_forms: coachingFormsFromOptions }
                setFormData(formDataClone);
                setCoachingFormsLoading(false);
            }
        }).catch(() => {
            setApiErrors({
                errors: 'Der Server ist aktuell nicht erreichbar. Bitte probieren Sie es später erneut.'
            });
            setCoachingFormsLoading(false);
        });
    }, []);

    return (
        <div className="single-tab-item">
            <Form
                unSavedChanges={unSavedChanges}
                handleSubmit={handleSubmit}
                isLoading={isLoading}
                responseMessage={responseMessage}
                responseMessageClass={responseMessageClass}
                generalErrors={ errors.general_error ? errors.general_error : null}
                intro="Bitte markieren Sie, in welcher Form Sie beraten. Die Auswahl ist auch Basis für die Suche auf der FPSB-Webseite."
            >
                { coachingFormsLoading ? (
                    <div className="form-group checkboxes no-label">
                        <div className="checkbox-inputs-wrapper">
                            {[...Array(expectedAmountCoachingForms)].map((k,i) =>
                                <div className="single-checkbox" key={'cf_' + i}>
                                    <input type="checkbox" disabled />
                                    <label><div className="checkbox-loader"></div></label>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <ApiCheck errors={apiErrors ? apiErrors : null}>
                        <Checkboxes
                            name='coaching_forms'
                            onChange={(item:IOption, wasChecked:boolean) => {
                                if (wasChecked) {
                                    let x = formData.coaching_forms.filter(el => {
                                        return el.value !== item.value
                                    });
                                    handleChange(null, 'coaching_forms', x);
                                } else {
                                    let x = structuredClone(formData.coaching_forms);
                                    x.push(item);
                                    handleChange(null, 'coaching_forms', x);
                                }
                            }}
                            value={formData?.coaching_forms}
                            options={coachingFormList}
                            error={errors['coaching_forms']}
                        />
                    </ApiCheck>
                ) }
            </Form>
        </div>
    )
}

export default TabCoachingForms;
